module.exports = __webpack_public_path__ + "img/find_sample2.aad25349.png";